import { message } from "antd";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { useGetUserInfo, useValidateToken } from "./hooks/api/user/hooks";
import AppLayout from "./views/layout/layout";
import Login from "./views/pages/auth/Login";
import { Suspense } from "react";
import { NuqsAdapter } from "nuqs/adapters/react-router/v7";
import SiteLoader from "./views/components/SiteLoader";

function App() {
  const { isLoading, isFetching, isError, error } = useValidateToken();
  const [messageApi, contextHolder] = message.useMessage();

  if (isError || error) {
    window.localStorage.clear();
    messageApi.error("Unauthorized. Login Again!!");
  }

  return (
    <NuqsAdapter>
      <BrowserRouter basename="/">
        {contextHolder}
        {isLoading || isFetching ? (
          <SiteLoader />
        ) : isError ? (
          <Login />
        ) : (
          <Suspense fallback={<SiteLoader />}>
            <AppLayout />
          </Suspense>
        )}
      </BrowserRouter>
    </NuqsAdapter>
  );
}

export default App;
